import { render } from "./filter.vue?vue&type=template&id=87ad2460&scoped=true"
import script from "./filter.vue?vue&type=script&lang=js"
export * from "./filter.vue?vue&type=script&lang=js"

import "./filter.vue?vue&type=style&index=0&id=87ad2460&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ad2460"]])

export default __exports__